import Description from '@/components/product/info-blocks/about.vue';
import Availability from '@/components/product/info-blocks/product-info-availability.vue';
import Delivery from '@/components/product/info-blocks/delivery.vue';
import Review from '@/components/product/reviews.vue';
import infoBlockConfig, { DESCRIPTION_INFO_DATA, AVAILABILITY_INFO_DATA, DELIVERY_INFO_DATA, REVIEW_INFO_DATA } from '@/components/product/info-blocks/info-blocks-config';
import { mapState } from 'vuex';

export default {
  components: {
    Description,
    Availability,
    Delivery,
    Review,
  },

  computed: {
    ...mapState('product', ['isReviewsAvailable']),

    availableItems() {
      return infoBlockConfig.filter(({ key }) => key === REVIEW_INFO_DATA.key ? this.isReviewsAvailable : true);
    },
  },

  methods: {
    getComponent(key) {
      switch(key) {
        case DESCRIPTION_INFO_DATA.key:
          return Description;
        case REVIEW_INFO_DATA.key:
          return Review
        case AVAILABILITY_INFO_DATA.key:
          return Availability;
        case DELIVERY_INFO_DATA.key:
          return Delivery;
        default:
            throw new Error('нет такого ключа');
      }
    }
  },
}
